import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

const AccountListCrossBorderPaymentSkeleton = (): JSX.Element => {
    return (
        <div className="account-list-cbp__skeleton">
            <div className="account-list-cbp__skeleton-info-img-container">
                <DarkSkeleton className="account-list-cbp__skeleton-info-img" height={135} width={135} />
            </div>
            <div className="account-list-cbp__skeleton-info-description">
                <DarkSkeleton height={16} width="98%" />
                <DarkSkeleton height={16} width="100%" />
                <DarkSkeleton height={16} width="90%" />
                <DarkSkeleton height={16} width="40%" />
                <DarkSkeleton className="account-list-cbp__skeleton-info-link" height={26} width={110} />
            </div>
            <span className="account-list-cbp__skeleton-title">
                <DarkSkeleton height={25} width={100} />
            </span>
            <DarkSkeleton className="account-list-cbp__skeleton-list-title" height={20} width={220} />
            <ul className="account-list-cbp__skeleton-list">
                {Array.from(Array(5)).map((_, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={index} className="account-list-cbp__skeleton-list-item">
                        <DarkSkeleton className="account-list-cbp__skeleton-account-alias" height={16} width="60%" />
                        <DarkSkeleton className="account-list-cbp__skeleton-account-number" height={16} width="40%" />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AccountListCrossBorderPaymentSkeleton;
